import {
    InstitutionResponseData,
    SingularDataResponse,
    ResponseData,
    NestedResponseData, 
    TripleNestedResponseData, 
    FactorsResponse, 
    FactorsListResponse,
    TextResponse,
    OtherTextResponse,
    OtherTextResponseStayLeave
} from "../models/responseData";


export const determineResponseTypeInstitutionResponseData = (response: any): response is InstitutionResponseData => true;

export const determineResponseTypeSingularResponseData = (response: any): response is SingularDataResponse => true;

export const determineResponseTypeResponseData = (response: any): response is ResponseData => true;

export const determineResponseTypeNestedResponseData = (response: any): response is NestedResponseData => true;

export const determineResponseTypeTripleNestedResponseData = (response: any): response is TripleNestedResponseData => true;


export const determineResponseTypeFactorsResponse = (response: any): response is FactorsResponse => true;

export const determineResponseTypeFactorsListResponse = (response: any): response is FactorsListResponse => true;

export const determineResponseTypeTextResponse = (response: any): response is TextResponse => true;

export const determineResponseTypeOtherTextResponse = (response: any): response is OtherTextResponse => true;

export const determineResponseTypeOtherTextStayLeave = (response: any): response is OtherTextResponseStayLeave => true;
